import React, { useRef, useState } from "react";
import WithPortal from "./WithPortal";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";

const BooleanSelect = ({
  showSearch,
  name,
  value,
  onClick,
  id,
  disabled,
  selectedOptions,
  options,
  dynamicOptions,
  label,
  apiCall,
  onChange,
  isLoading,
  inputBoxSize = "small",
  size = "small",
  isEditList = false,
  editListHandler = () => null,
  useFetchHook,
  handleCallHook,
  noKeyboardNavigation,
  displayValue,
  isError,
}) => {
  const [open, setIsOpen] = React.useState(false);
  const [isSelected, setIsSelected] = useState("");

  const optionBaseClass = `w-full  hover:bg-[#F0F0F0] text-[#383838] cursor-pointer rounded-md px-[5px]  ${
    size === "small" ? "py-1 my-1 text-[0.8rem]" : "py-2 my-1  text-[.9rem]"
  }`;

  const inputRef = useRef(null);
  const handleClickSelect = () => {
    console.log(open, "sdfjd");

    setIsOpen(!open);
    // if (apiCall) {
    //   console.log(apiCall, "hello India aakash");
    //   apiCall("");
    // } else if (dynamicOptions) {
    //   onClick();
    // } else if (handleCallHook) {
    //   handleCallHook();
    // }
  };

  const handleSelectdOption = (selectedVal) => {
    console.log(selectedVal, "sdfjd jk");
    setIsSelected(selectedVal);
    // onChange(value);
    onChange?.({
      target: {
        name,
        value: selectedVal,
        label: selectedVal ? options?.[0]?.label : options?.[1]?.label,
      },
    });
    setIsOpen(false);
  };

  const errorStyleClass = "border-b-2 border-b-[#EF4444]";
  const activeStyleClass = "border-blue-500";
  const disabledStyleClass = "border-DFE2E5 bg-EDEDED text-868686 cursor-not-allowed";

  const dynamicClassDefinition = () => {
    if (disabled) {
      return disabledStyleClass;
    } else if (open) {
      return activeStyleClass;
    } else if (value !== true && value !== false && isError) {
      return errorStyleClass;
    }
  };

  return (
    <>
      <div
        onClick={() => {
          handleClickSelect();
        }}
        className={`rounded border border-DFE2E5 bg-white text-434852 cursor-pointer focus:outline-hidden focus:ring-0 focus:border-1D5D9B active:border active:border-DFE2E5 text-xs  w-full h-7 p-1 px-2 whitespace-nowrap overflow-hidden text-ellipsis flex justify-between items-center ${dynamicClassDefinition()}`}
        style={{
          // padding: size === "small" ? "0.3rem 0.7rem" : "1.02rem 0.7rem 1.02rem 0.7rem",
          padding: size === "small" ? "0.3rem 0.4rem" : "1.02rem 0.714rem 1.02rem 0.714rem",

          fontSize: size === "small" ? "0.8rem" : ".9rem",
        }}
        ref={inputRef}
      >
        <p>
          {value === true || value === false ? (
            <span className={`${value ? "text-[#3DB22A]" : "text-[#EF4444]"} flex items-center`}>
              <i className={`bi ${value ? "bi-check-circle-fill" : "bi-x-circle-fill"} mr-1`} />
              {value ? options?.[0]?.label || "Yes" : options?.[1]?.label || "No"}
            </span>
          ) : (
            <span className="text-[#AFAFAF]">{`Select ${label}`}</span>
          )}
        </p>

        <DownArrow fill={`#7A7D84`} className={`${open ? "rotate-180 " : "rotate-0"} transition-all duration-300 `} />
      </div>

      {open && (
        <WithPortal open={open} onClose={() => setIsOpen(false)} mode="vertical" xMargin={-10} containerRef={inputRef}>
          <div
            className={`flex items-center flex-col bg-white p-2.5 border rounded-lg shadow-inner min-w-[150px] transform transition-all duration-200 origin-top`}
          >
            {console.log(isSelected, "hemllloooooisselected")}
            <div
              className={`text-[#3DB22A] ${optionBaseClass} ${isSelected ? "bg-[#E8F2FF]" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                handleSelectdOption(true);
              }}
            >
              <i className="bi bi-check-circle-fill mr-1" />
              <span> {options?.[0]?.label || "Yes"} </span>
            </div>

            <div
              className={`text-[#EF4444] ${optionBaseClass}  ${isSelected === false ? "bg-[#E8F2FF]" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                handleSelectdOption(false);
              }}
            >
              <i className="bi bi-x-circle-fill mr-1" />
              <span> {options?.[1]?.label || "No"} </span>
            </div>
          </div>
        </WithPortal>
      )}
    </>
  );
};

export default BooleanSelect;
